import { Inject, Injectable } from '@angular/core';
import { Observable, map, catchError, of } from 'rxjs';
import { ApiService } from 'core/api/services/api.service';
import { UserApiService } from 'features/user/api/api-tokens';
import { MappingExportEnvelope, MappingVersion, SavedColumnMapping } from '../models/bulk-payment.model';

@Injectable({
  providedIn: 'root',
})
export class BulkPaymentMappingService {
  private readonly MAPPING_TYPE = 'BULK_PAYMENT_COLUMN';
  private readonly MAPPING_NAME = 'default';

  constructor(@Inject(UserApiService) private apiService: ApiService) {}

  public getSavedMapping(): Observable<SavedColumnMapping | null> {
    return this.apiService
      .get<{ mapping: SavedColumnMapping | null }>('csvMappingGet', {
        urlParams: {
          mappingType: this.MAPPING_TYPE,
          mappingName: this.MAPPING_NAME,
        },
      })
      .pipe(
        map((response) => response.mapping ?? null),
        catchError(() => of(null))
      );
  }

  public saveMapping(mapping: SavedColumnMapping): Observable<SavedColumnMapping | null> {
    return this.apiService
      .put<{ mapping: SavedColumnMapping }>('csvMappingSave', {
        urlParams: {
          mappingType: this.MAPPING_TYPE,
          mappingName: this.MAPPING_NAME,
        },
        body: mapping,
      })
      .pipe(
        map((response) => response.mapping),
        catchError(() => of(null))
      );
  }

  public listVersions(): Observable<MappingVersion[]> {
    return this.apiService
      .get<{ versions: MappingVersion[] }>('csvMappingVersions', {
        urlParams: {
          mappingType: this.MAPPING_TYPE,
          mappingName: this.MAPPING_NAME,
        },
      })
      .pipe(
        map((response) => response.versions ?? []),
        catchError(() => of([]))
      );
  }

  public buildEnvelope(version: MappingVersion): MappingExportEnvelope {
    return {
      mappingType: this.MAPPING_TYPE,
      mappingName: this.MAPPING_NAME,
      version: version.version,
      exportedAt: new Date().toISOString(),
      mapping: version.mapping,
    };
  }
}
